export const ENCODER_SEPARATOR = "::";

// Color constants for range values
export const RANGE_EMPTY_LIGHT = "red.300";
export const RANGE_EMPTY_DARK = "red.800";
export const RANGE_0_LIGHT = "red.100";
export const RANGE_0_DARK = "red.600";
export const RANGE_1_LIGHT = "green.100";
export const RANGE_1_DARK = "green.400";
export const RANGE_2_LIGHT = "green.200";
export const RANGE_2_DARK = "green.500";
export const RANGE_3_LIGHT = "green.300";
export const RANGE_3_DARK = "green.600";
export const RANGE_4_LIGHT = "green.400";
export const RANGE_4_DARK = "green.700";
export const RANGE_FULL_LIGHT = "green.500";
export const RANGE_FULL_DARK = "green.800";
